"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconProgressOngoing = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconProgressOngoing = function IconProgressOngoing(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12S0 18.628 0 12C0 5.373 5.373 0 12 0zm-.258 5.831a2.09 2.09 0 00-2.893 0 1.944 1.944 0 000 2.808L12.31 12l-3.462 3.36a1.946 1.946 0 000 2.809c.4.387.923.581 1.446.581.524 0 1.048-.194 1.447-.581l4.91-4.765a1.946 1.946 0 000-2.808z"
  }));
};
exports.IconProgressOngoing = IconProgressOngoing;